// `@nackle/intl-tools` ships Babel output that reads a bare global `regeneratorRuntime` without
// requiring the runtime itself. That global used to arrive via `@babel/polyfill`, a peer dep of
// `@nackle/bridge` 2.x — bridge 3.x declares no peers, so nothing defines it any more and
// `updateLanguageBundle` throws. Imported here, ahead of the federation boundary below, so the
// global exists before any vendor chunk runs.
import 'regenerator-runtime/runtime';

import( './bootstrap' );
